import { TextField } from '@material-ui/core';
import React from 'react';

export const StepInput = ({ value, label, onChange, error, field = 'archToTreatUpperStep', disabled }) => {
    return (
        <TextField
            disabled={disabled}
            value={value}
            label={label}
            type="number"
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{ inputProps: { min: 0 } }}
            variant="standard"
            onChange={(e) => onChange(field, e.target.value)}
            error={error}
            helperText={error && 'Please enter a valid number'}
        />
    );
};

export default StepInput;
